import startCase from "lodash/startCase";
import camelCase from "lodash/camelCase"

/**
 * Model representing a single entry in the subscription table
 */
export default class SubscriptionEntry {
  public productName: string;
  public currentPeriodStart: number;
  public nextBillingDate: number;
  public subscriptionTier: number;
  public currentAmountDue: number | null;
  public currentAmountDueEur: number | null;
  public currentPeriodProfit: number | null
  public status: SubscriptionStatus;
  public cancelAtPeriodEnd: boolean;
  public lastProfitTime: number;

  constructor(rawScheduleEntry: any) {
    this.productName = rawScheduleEntry.productName;
    this.currentPeriodStart = rawScheduleEntry.currentPeriodStart;
    this.nextBillingDate = rawScheduleEntry.nextBillingDate;
    this.subscriptionTier = rawScheduleEntry.subscriptionTier;
    this.currentAmountDue = rawScheduleEntry.currentAmountDue;
    this.currentAmountDueEur = rawScheduleEntry.currentAmountDueEur;
    this.currentPeriodProfit = rawScheduleEntry.lastProfitCalculated
    this.status = startCase(camelCase(rawScheduleEntry.status)) as SubscriptionStatus;
    this.cancelAtPeriodEnd = rawScheduleEntry.cancelAtPeriodEnd;
    this.lastProfitTime = rawScheduleEntry.lastProfitTime;
  }

  // Example value of the model
  public static example = new SubscriptionEntry({
    currentPeriodStart: 1600043000,
    nextBillingDate: 1600243000,
    subscriptionTier: 1,
    currentAmountDue: 15.34,
    currentAmountDueEur: 12.20,
    status: "active",
    cancelAtPeriodEnd: false,
    lastProfitTime: 1600243000
  });
}

export enum SubscriptionStatus {
  Active = "Active",
  Incomplete = "Incomplete",
  IncompleteExpired = "Incomplete Expired",
  PastDue = "Past Due",
  Canceled = "Canceled",
  Unpaid = "Unpaid"
}
